import { useState, useEffect } from 'react';
import type { FutebolBolaoPalpite } from '@/shared/types';
import { futebolRepository } from '../../data/futebolRepository';

/**
 * Carrega palpites + vencedores do bolão para um placar final.
 * placarCasa/Visitante entram porque buscarVencedoresBolao filtra no servidor.
 */
export function useBolaoHistorico(
  telaId: string,
  fixtureId: number,
  placarCasa: number,
  placarVisitante: number,
): {
  palpites: FutebolBolaoPalpite[];
  vencedores: FutebolBolaoPalpite[];
  loading: boolean;
  erro: boolean;
} {
  const [palpites, setPalpites] = useState<FutebolBolaoPalpite[]>([]);
  const [vencedores, setVencedores] = useState<FutebolBolaoPalpite[]>([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    let cancelado = false;
    setLoading(true);
    setErro(false);
    Promise.all([
      futebolRepository.buscarVencedoresBolao(telaId, fixtureId, placarCasa, placarVisitante),
      futebolRepository.buscarTodosPalpites(telaId, fixtureId),
    ])
      .then(([ganhadores, todos]) => {
        if (cancelado) return;
        setVencedores(ganhadores);
        setPalpites(todos);
      })
      .catch(() => { if (!cancelado) setErro(true); })
      .finally(() => { if (!cancelado) setLoading(false); });
    return () => { cancelado = true; };
  }, [telaId, fixtureId, placarCasa, placarVisitante]);

  return { palpites, vencedores, loading, erro };
}
